export default {
  title: "GabiFlix",
  favicon: "gabiflix/favicon.ico",
  customHead: "",
  typography: {
    source:
      "https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap",
    H1: {
      font_size: "30px",
      line_height: "34px",
      letter_spacing: 0.1,
      font_family: "Sora",
      font_weight: 600,
    },
    H2: {
      font_size: "27px",
      line_height: "28px",
      letter_spacing: -0.4,
      font_family: "Sora",
      font_weight: 400,
    },
    H3: {
      font_size: "23px",
      line_height: "24px",
      letter_spacing: 0,
      font_family: "Sora",
      font_weight: 500,
    },
    H4: {
      font_size: "18px",
      line_height: "20px",
      letter_spacing: 0,
      font_family: "Sora",
      font_weight: 400,
    },
    H5: {
      font_size: "16px",
      line_height: "18px",
      letter_spacing: 0,
      font_family: "Sora",
      font_weight: 200,
    },
    P: {
      font_size: "13px",
      line_height: "15px",
      letter_spacing: 0.3,
      font_family: "Sora",
      font_weight: 400,
    },
  },
  colors: {
    main: "#63DBF6",
    light: "#FBFEFF",
    dark: "#000608",
    gray: "#62696B",
  },
  background: {
    mode: "LIGHT",
  },
  sections: [
    {
      mode: "LIGHT",
      type: "ROUNDEDHERO",
      header: {
        logo: "gabiflix/logo-dark.svg",
        login: "https://app.ginastee.com/gabiflix",
        options: [
          {
            text: "Conteúdos",
            action: "#content",
          },
          {
            text: "Dúvidas",
            action: "#faq",
          },
          {
            text: "Planos",
            action: "#pricing",
          },
        ],
      },
      background: {
        type: "IMAGE",
        wide: {
          path: "gabiflix/hero-bg-wide.png",
          type: "IMAGE",
        },
        mobile: {
          path: "gabiflix/hero-bg-mobile.png",
          type: "IMAGE",
        },
      },
      content: [
        {
          type: "TEXT",
          settings: {
            variant: "H2",
            color: "light",
            text: "Emagreça, recupere sua autoestima e volte a gostar do que vê no espelho.",
            style: {
              textAlign: "left",
            },
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              textAlign: "left",
              opacity: 0.93,
              maxWidth: "400px",
            },
            variant: "H5",
            color: "light",
            text: "Com a comunidade GabiFlix você alcança resultados consistentes, eliminando a gordura localizada, e recuperando sua auto estima.",
          },
        },
        {
          type: "ROW",
          settings: {
            style: {
              gap: "14px",
              flexWrap: "wrap",
            },
            content: [
              {
                type: "BUTTONLINEAR",
                settings: {
                  variant: "SECONDARY",
                  text: "Entrar por apenas R$0,86 / dia",
                  redirect: "#prices",
                  textColor: "white",
                },
              },
            ],
          },
        },
      ],
    },
    {
      type: "INFO",
      config: {
        display: "FLEX_WRAP",
        max_columns: 2,
      },
      style: {
        alignItems: "center",
        maxWidth: "1150px",
        margin: "0 auto",
      },
      content: [
        {
          type: "BOX",
          settings: {
            style: {
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
            content: [
              {
                type: "LABEL_ICON_TEXT",
                settings: {
                  text: "Progresso",
                  icon: "line_chart",
                  iconColor: "white",
                },
              },
              {
                type: "TEXT",
                settings: {
                  variant: "H2",
                  style: {
                    marginTop: 7,
                    marginBottom: -10,
                    textAlign: "left",
                  },
                  text: "A primeira plataforma que utiliza a neuroplasticidade direcionada a queima de gordura",
                },
              },
              {
                type: "TEXT",
                settings: {
                  variant: "P",
                  text: "A plataforma GabiFlix contém os técnicas para mulheres com uma rotina corrida conseguirem perder medidas e queimar gordura, alcançando sua melhor versão em tempo récorde.",
                  style: {
                    opacity: 0.75,
                    textAlign: "left",
                  },
                },
              },
              {
                type: "BUTTONLINEAR",
                settings: {
                  variant: "SECONDARY",
                  text: "Quero começar minha transformação",
                  redirect: "#prices",
                  textColor: "white",
                },
              },
            ],
          },
        },
        {
          type: "MEDIA_COLUMNS_SCROLL",
          settings: {
            content: [
              [
                "gabiflix/modules/m- (1).png",
                "gabiflix/modules/m- (2).png",
                "gabiflix/modules/m- (9).png",
                "gabiflix/modules/m- (3).png",
                "gabiflix/modules/m- (4).png",
                "gabiflix/modules/m- (7).png",
                "gabiflix/modules/m- (8).png",
                "gabiflix/modules/m- (6).png",
                "gabiflix/modules/m- (5).png",
                "gabiflix/modules/m- (1).png",
              ],
              [
                "gabiflix/modules/m- (6).png",
                "gabiflix/modules/m- (7).png",
                "gabiflix/modules/m- (8).png",
                "gabiflix/modules/m- (4).png",
                "gabiflix/modules/m- (3).png",
                "gabiflix/modules/m- (5).png",
                "gabiflix/modules/m- (1).png",
                "gabiflix/modules/m- (4).png",
                "gabiflix/modules/m- (9).png",
                "gabiflix/modules/m- (2).png",
              ],
              [
                "gabiflix/modules/m- (7).png",
                "gabiflix/modules/m- (8).png",
                "gabiflix/modules/m- (6).png",
                "gabiflix/modules/m- (5).png",
                "gabiflix/modules/m- (1).png",
                "gabiflix/modules/m- (1).png",
                "gabiflix/modules/m- (2).png",
                "gabiflix/modules/m- (9).png",
                "gabiflix/modules/m- (3).png",
                "gabiflix/modules/m- (4).png",
              ],
            ],
          },
        },
      ],
    },
    {
      type: "INFO",
      content: [
        {
          type: "IMAGE",
          settings: {
            style: {
              maxWidth: "280px",
              alignSelf: "center",
              marginBottom: "-74px",
            },
            path: "gabiflix/character.png",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              textAlign: "center",
              maxWidth: 600,
              margin: "0 auto",
              marginBottom: 40,
              fontWeight: 700,
            },
            variant: "H3",
            color: "dark",
            text: "<i>A plataforma GabiFlix é o lugar onde a neuroplasticidade trabalha a seu favor para vencer a preguiça, compulsão e a falta de foco</i>",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              textAlign: "center",
              maxWidth: 600,
              margin: "0 auto",
              marginBottom: 20,
              fontWeight: 700,
            },
            variant: "H2",
            color: "dark",
            text: "Elas também achavam que não conseguiam",
          },
        },
        {
          type: "ROW",
          settings: {
            style: {
              gap: "14px",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              padding: 14,
            },
            content: [
              {
                type: "IMAGE",
                settings: {
                  style: {
                    width: "100%",
                    maxWidth: "350px",
                    height: "auto",
                    borderRadius: "10px",
                    overflow: "hidden",
                  },
                  path: "gabiflix/gf01.jpeg",
                },
              },
              {
                type: "IMAGE",
                settings: {
                  style: {
                    width: "100%",
                    maxWidth: "350px",
                    height: "auto",
                    borderRadius: "10px",
                    overflow: "hidden",
                  },
                  path: "gabiflix/gf02.jpeg",
                },
              },
              {
                type: "IMAGE",
                settings: {
                  style: {
                    width: "100%",
                    maxWidth: "350px",
                    height: "auto",
                    borderRadius: "10px",
                    overflow: "hidden",
                  },
                  path: "gabiflix/gf03.jpeg",
                },
              },
            ],
          },
        },
      ],
    },
    {
      type: "INFO",
      content: [
        {
          type: "LABEL_ICON_TEXT",
          settings: {
            style: {
              alignSelf: "center",
            },
            text: "Gamificação",
            icon: "game",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              textAlign: "center",
              maxWidth: 400,
              margin: "0 auto",
              fontWeight: 700,
            },
            variant: "H2",
            color: "dark",
            text: "Ganhe prêmios com suas atividades",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              textAlign: "center",
              maxWidth: 400,
              margin: "0 auto",
              marginBottom: "-40px",
              marginTop: "-22px",
              opacity: 0.7,
            },
            variant: "P",
            color: "dark",
            text: "Nos desafios trimestrais, você pontua e ganha prêmios conforme sobe no ranking",
          },
        },
      ],
    },
    {
      type: "GALERY_FLOATING",
      style: {
        maxWidth: "750px",
      },
      content: [
        "gabiflix/challenge-01.png",
        "gabiflix/challenge-02.png",
        "gabiflix/challenge-03.png",
        "gabiflix/challenge-04.png",
      ],
    },
    {
      type: "INFO",
      background: {
        color: "var(--color-dark)",
      },
      style: {
        padding: "30px",
        borderRadius: "30px",
      },
      content: [
        {
          type: "IMAGE",
          settings: {
            style: {
              maxWidth: "137px",
              alignSelf: "center",
            },
            path: "gabiflix/logo-white.svg",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              marginTop: 30,
            },
            variant: "H1",
            color: "light",
            text: "O que é a comunidade GabiFlix?",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              maxWidth: 750,
              margin: "0 auto",
            },
            variant: "P",
            color: "light",
            text: "Eu, Gabi Sales, transformo a auto estima de mulheres através da atividade física, permitindo com que elas alcancem sua melhor versão. Esculpi pessoalmente um ambiente com um único objetivo…",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              maxWidth: 750,
              margin: "10px auto",
              fontWeight: 600,
            },
            variant: "H4",
            color: "main",
            text: "FAZER COM QUE VOCÊ SE OLHE NO ESPELHO E TENHA ORGULHO DO QUE VÊ.",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              maxWidth: 750,
              margin: "0 auto",
            },
            variant: "P",
            color: "light",
            text: "Sem técnica milagrosa e direto ao ponto, reuni anos de conquistas e conhecimento em um único lugar. Tudo isso para acelerar ao extremo seus resultados: queimar gordura localizada no conforto da sua casa.",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              maxWidth: "700px",
              alignSelf: "center",
              marginTop: 15,
            },
            variant: "H1",
            color: "light",
            text: "Atenção!!!",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              maxWidth: "700px",
              alignSelf: "center",
            },
            variant: "H2",
            color: "light",
            text: "<span style='color: var(--color-main)'><b>A GabiFLix não é um curso</b></span>",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              maxWidth: "700px",
              alignSelf: "center",
              marginTop: 0,
            },
            variant: "P",
            color: "light",
            text: "Vou te revelar os segredos por trás dos resultados que entrego diariamente para minhas alunas.",
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              maxWidth: "700px",
              alignSelf: "center",
              marginTop: 0,
            },
            variant: "P",
            color: "light",
            text: "Diferentemente do que você vê por aí, a comunidade é um ambiente que promove evolução através de desafios, premiações e muito conhecimento.",
          },
        },
        {
          type: "BUTTONLINEAR",
          settings: {
            style: {
              alignSelf: "center",
              marginTop: "20px",
              marginBottom: "12px",
            },
            variant: "SECONDARY",
            text: "Quero começar minha transformação",
            redirect: "#prices",
            textColor: "white",
          },
        },
      ],
    },
    {
      type: "INFO",
      config: {},
      background: {},
      style: {
        borderRadius: "30px",
        justifyContent: "space-between",
        padding: 14,
        paddingBottom: "50px",
      },
      content: [
        {
          type: "TEXT",
          settings: {
            style: {
              textAlign: "center",
              marginTop: "11px",
              opacity: 0.93,
              maxWidth: "600px",
              alignSelf: "center",
            },
            variant: "H1",
            color: "dark",
            text: "Veja o que nossas musas estão falando da <b>GabiFlix</b>",
          },
        },
        {
          type: "ROW",
          settings: {
            style: {
              gap: "14px",
              flexWrap: "wrap",
              justifyContent: "center",
              marginTop: "18px",
            },
            content: [
              {
                type: "VIDEO",
                settings: {
                  style: {
                    maxWidth: "290px",
                  },
                  src: "gabiflix/depoimento-01.mp4#t=0.001",
                },
              },
              {
                type: "VIDEO",
                settings: {
                  style: {
                    maxWidth: "290px",
                  },
                  src: "gabiflix/depoimento-02.mp4#t=0.001",
                },
              },
              {
                type: "VIDEO",
                settings: {
                  style: {
                    maxWidth: "290px",
                  },
                  src: "gabiflix/depoimento-03.mp4",
                },
              },
            ],
          },
          background: {
            color: "rgba(0, 0, 0, 0.072)",
          },
          style: {
            borderRadius: "30px",
            justifyContent: "space-between",
            padding: 14,
          },
        },
      ],
    },
    {
      type: "INFO",
      config: {
        id: "prices",
      },
      background: {
        color: "var(--color-dark)",
      },
      style: {
        borderRadius: "30px",
        justifyContent: "center",
        padding: 14,
        paddingBottom: 20,
      },
      content: [
        {
          type: "TEXT",
          settings: {
            style: {
              marginTop: 30,
            },
            variant: "H1",
            color: "light",
            text: 'Preço especial de lançamento por <b style="color: var(--color-main)">tempo limitado</b>',
          },
        },
        {
          type: "TEXT",
          settings: {
            style: {
              maxWidth: 600,
              margin: "0 auto",
              marginBottom: 20,
            },
            variant: "P",
            color: "light",
            text: "Por menos de 1 real por dia, você será <b>transformada nas próximas 4 semanas</b> aplicando tudo que entrego a você!",
          },
        },
        {
          type: "PRICE_BOX",
          settings: {
            mode: "MAIN",
            id: "",
            title: "Plano Anual",
            logo: "gabiflix/logo-white.svg",
            benefits: [
              "Desafio de 30 dias",
              "Treinamento em casa",
              "Treino focado em glúteos",
              "Desafios premiados",
              "🎁 [BÔNUS] Grupo com suporte no WhatsApp",
            ],
            prices: [
              {
                interval: "year",
                installments: 12,
                price: 1505,
                fullPrice: 49700,
                href: "https://pay.ginastee.com/ck-6u6imbd?plan=110000067&[COUPON]",
              },
            ],
            cta: {
              text: "ASSINAR ANUAL",
            },
          },
        },
      ],
    },
    {
      type: "FAQ",
      mode: "LIGHT",
      settings: {
        title: "Dúvidas frequentes",
        description: "Tire suas dúvidas",
        questions: [
          {
            title: "Quando vou receber meu acesso?",
            answer:
              "Assim que você realizar o pagamento, você será redirecionado instantaneamente para seu acesso via aplicativo, onde estarão todos os conteúdos e grupos.",
          },
          {
            title: "Sou profissional, serve para mim?",
            answer:
              "Claro! Aqui na comunidade, será passado um conhecimento aprofundado, que com certeza vai aumentar seu repertório profissional.",
          },
          {
            title: "Sou iniciante, serve para mim?",
            answer:
              "Com certeza! Nas aulas te guiaremos desde o conhecimento básico até avançado. Com os conteúdos sendo atualizados regularmente para que você continue evoluindo.",
          },
          {
            title: "Tem garantia?",
            answer:
              "Somos tão confiantes de que você terá uma transformação garantida, que, se você, dentro de 7 dias, por algum motivo se arrepender, devolvemos seu dinheiro por completo.",
          },
          {
            title: "Porque devo entrar agora?",
            answer:
              "Enquanto você está na dúvida se realmente decide iniciar essa nova etapa, outras pessoas já estão construindo o shape dos sonhos.<br/><br/>Toda essa transformação vem do conhecimento único que você adquire na nossa comunidade.",
          },
        ],
      },
    },
  ],
};
